<script setup>

</script>

<template>
    <div class="w-16 h-16 rounded-2xl bg-rose-100 flex items-center justify-center">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#EF4444" fill-opacity="0.15"/>
            <path d="M9 9L15 15M15 9L9 15" stroke="#EF4444" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </div>
</template>

<style scoped>

</style>
